import React from "react";
import { Box, Button, Menu, MenuItem, Select, TextField } from "@mui/material";
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import { TOKENS } from './campaignTextUtils';
import CampaignTextValidationErrors from "./CampaignTextValidationErrors";

type Props = {
  text: string;
  setText: (t: string) => void;
  template: string;
  setTemplate: (t: string) => void;
  messageTemplates: any;
  templatesLoading: boolean;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  textFieldRef: React.RefObject<HTMLInputElement>;
  validationErrors: any[];
  showValidationErrors: boolean;
  handleSelectChange: (e: any) => void;
  handleTokenClick: (token: string) => void;
  setLinkDialogOpen: (b: boolean) => void;
  setPendingLinkInsert: (b: boolean) => void;
};

export default function CampaignTextEditor({
  text,
  setText,
  template,
  setTemplate,
  messageTemplates,
  templatesLoading,
  anchorEl,
  setAnchorEl,
  textFieldRef,
  validationErrors,
  showValidationErrors,
  handleSelectChange,
  handleTokenClick,
}: Props) {
  return (
    <>
      <Box sx={styles.templateRow}>
        <Select
          id="campaint-template"
          size='small'
          value={template}
          sx={styles.selectFieldTemplate}
          onChange={handleSelectChange}
          disabled={!messageTemplates}
        >
          <MenuItem value="1">Template #1 - Performance</MenuItem>
          <MenuItem value="2">Template #2 - New song</MenuItem>
          <MenuItem value="3">Template #3 - New merch</MenuItem>
          <MenuItem value="4">Template #4 - Interview</MenuItem>
        </Select>
        <Box sx={styles.flexSpacer} />
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EmojiObjectsOutlinedIcon />}
          onClick={e => setAnchorEl(e.currentTarget)}
          sx={styles.tokensChip}
        >
          Add token
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          {TOKENS.map(token =>
            <MenuItem key={token.key} onClick={() => handleTokenClick(token.key)}>
              <Box sx={styles.tokenMenuItemBox}>
                <span style={styles.tokenMenuItemLabel}>[{token.key}]</span>
              </Box>
            </MenuItem>
          )}
        </Menu>
      </Box>
      <Box sx={styles.scrollableContent}>
        <TextField
          id="campaign-text"
          multiline
          rows={6}
          value={text}
          onChange={e => setText(e.target.value)}
          variant="outlined"
          fullWidth
          sx={styles.textField}
          inputRef={textFieldRef}
        />
        <CampaignTextValidationErrors
          validationErrors={validationErrors}
          showValidationErrors={showValidationErrors}
        />
      </Box>
    </>
  );
}

const styles = {
  templateRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 1,
    marginBottom: 1,
    flexShrink: 0,
  },
  selectFieldTemplate: {
    marginRight: 2,
  },
  flexSpacer: {
    flex: 1
  },
  tokensChip: {
    cursor: 'pointer',
    borderRadius: '20px',
    textTransform: 'none',
    fontWeight: 500,
    px: 2,
    py: 1,
    minWidth: 140,
  },
  tokenMenuItemBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },
  tokenMenuItemLabel: {
    color: "#888"
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    marginBottom: '16px',
    backgroundColor: "#eeeeee",
    minHeight: '150px',
    flexShrink: 0,
  },
};
